import { useEffect, useMemo } from 'react';
import { useListTagsQuery } from '../../../hinge-connect/tags/types';

export type Milliseconds = number;

export const useListTagNames = (props: {
  cacheValidationDuration: Milliseconds;
  skip?: boolean;
}): string[] => {
  const { data, refetch } = useListTagsQuery({ skip: props.skip });

  useEffect(() => {
    if (!props.skip && shouldRefetch(props.cacheValidationDuration)) {
      localStorage.setItem('tagNamesFetchTime', Date.now().toString());
      refetch();
    }
  }, [props.skip, props.cacheValidationDuration, refetch]);

  const tags = useMemo(
    () => data?.listTags.tags.map(tag => tag.name) ?? [],
    [data],
  );

  return tags;
};

function shouldRefetch(cacheValidationDuration: number): boolean {
  const lastFetchTime = localStorage.getItem('tagNamesFetchTime');

  if (!lastFetchTime) return true;

  const timeSinceLastFetch = Date.now() - parseInt(lastFetchTime);

  if (timeSinceLastFetch > cacheValidationDuration) return true;

  return false;
}
